export const updateLoyaltyGroup = (groupId: number) => {
	return {
		url: `loyalty-management/loyalty/group/${groupId}`,
		method: 'PUT',
	};
};
